import React from 'react';

export default class List extends React.Component {
  constructor(props) {
    super(props);
  }

  listItemRenderer({ index, key, avoidFirstLITag, ariaHidden,treatFirstItemAsHeadingAndIgnoreListBehavior,ignoreListBehavior,treatAsTabs }) {
    return (
      <>
        {((avoidFirstLITag && index === 0) || ignoreListBehavior) ? <div className="rilrtl-list-item" key={`list-item-${key}`}
          {...(ariaHidden && { 'aria-hidden': "true" })}
          {...(treatFirstItemAsHeadingAndIgnoreListBehavior && { 'role': "heading" })}

        >
          {this.props.listItemRenderer({ index, key })}
        </div> :
          <li
            className="rilrtl-list-item"
            key={`list-item-${key}`}
            {...(ariaHidden && { 'aria-hidden': "true" })}
            role={treatAsTabs ? 'tab' : undefined}
            aria-controls={treatAsTabs ? 'right-pane-body' : undefined}
            aria-selected={
              treatAsTabs
                ? this.props.getAriaSelected
                  ? this.props.getAriaSelected(index)
                  : undefined
                : undefined
            }
            tabIndex={
              treatAsTabs
                ? this.props.getAriaSelected(index)
                  ? 0
                  : -1
                : undefined
            }
            onKeyDown={
              treatAsTabs
                ? (e) => {
                  const li = e.currentTarget;
                  const allTabs = Array.from(
                    li.parentElement?.querySelectorAll('[role="tab"]') || []
                  );
                  const currentIndex = allTabs.indexOf(li);

                  let newIndex = -1;

                  switch (e.key) {
                    case "Enter":
                    case " ":
                      e.preventDefault();
                      // trigger click on immediate <div>
                      const firstDiv = li.querySelector(":scope > div");
                      if (firstDiv) (firstDiv).click();
                      break;

                    case "ArrowRight":
                    case "ArrowDown": // APG: right & down move forward
                      e.preventDefault();
                      newIndex = (currentIndex + 1) % allTabs.length;
                      break;

                    case "ArrowLeft":
                    case "ArrowUp": // APG: left & up move backward
                      e.preventDefault();
                      newIndex = (currentIndex - 1 + allTabs.length) % allTabs.length;
                      break;
                  }

                  if (newIndex >= 0) {
                    const newTab = allTabs[newIndex];
                    newTab.focus(); // move focus
                    const firstDiv = newTab.querySelector(":scope > div");
                    if (firstDiv) (firstDiv).click(); // activate
                  }
                }
                : undefined
            }
          >
            {this.props.listItemRenderer({ index, key })}
          </li>

        }
      </>
    );
  }

  render() {
    const {
      numOfItems,
      className = '',
      showSearch = false,
      luxe = false,
      listItemRenderer,
      isFleek = false,
      oldFlow,
      isFromFilter = false,
      avoidFirstLITag = false,
      ariaHidden = false,
      keepDefaultRole = false,
      treatFirstItemAsHeadingAndIgnoreListBehavior = false,
      ignoreListBehavior = false,
      treatAsTabs = false,
      ulAriaLabel,
      additionalUlStyles = {}
    } = this.props;
    {
      return numOfItems === 0 && showSearch ? (
        <div 
          className="no-result"
          aria-live='assertive'
          role='alert'
        >No results found</div>
      ) : (
        <ul 
            className={`rilrtl-list ${className}`}
            style={isFleek ? { background: isFromFilter ? '#060C10' : oldFlow !== undefined ? '#060C10' : '#2E343A' } : {
              ...additionalUlStyles
            }}
            {...(!keepDefaultRole && {
              'aria-label': `${avoidFirstLITag ? numOfItems - 1 : numOfItems} results are available.`,
              'aria-live': 'assertive',
              role: 'alert',
            })}
            {
              ...(keepDefaultRole && ulAriaLabel && {
                'aria-label': ulAriaLabel
              })
            }
            role={treatFirstItemAsHeadingAndIgnoreListBehavior || ignoreListBehavior ? 'presentation' : treatAsTabs ? 'tablist' : undefined}
        >
          {[...Array(numOfItems)].map((item, key) => {
            return this.listItemRenderer({ index: key, key,avoidFirstLITag, ariaHidden,treatFirstItemAsHeadingAndIgnoreListBehavior,ignoreListBehavior,treatAsTabs });
          })}
        </ul>
      );
    }
  }
}
